import {getElement} from "./utils/utils";
import {disableScroll} from "./utils/disableScroll";

const initHeader = () => {
    const headerMenuTrigger = getElement('.js-header-trigger')
    const headerMenu = getElement('.js-header-menu')
    const langSwitcher = getElement('.s-nav-menu > ul > .wpml-ls-item')

    if (!headerMenu || !headerMenuTrigger) {
        return null;
    }

    headerMenuTrigger.addEventListener('click', (e) => {
        e.preventDefault()
        headerMenu.classList.toggle('is-open')
        headerMenuTrigger.classList.toggle('is-active')
        disableScroll()
    })

    langSwitcher.addEventListener('click', (e) => {
        if (window.matchMedia("(max-width: 992px)").matches) {
            e.preventDefault()
            langSwitcher.classList.toggle('is-active')
        }
    })

    document.addEventListener('click', function (e) {
        if (!e.target.closest('.s-nav-menu > ul > .wpml-ls-item')) {
            langSwitcher.classList.remove('is-active')
        }
    })
}

export {initHeader}